import { createContext, ReactNode, useContext, useEffect, useState } from "react";
import api from "../utils/axios/api";
import { getFeeUniversal } from "../utils/fee";

interface FeeContextType {
    fee: number
    changeFee: (n: number) => void
}

export const FeeContext = createContext<FeeContextType | undefined>(undefined)

interface FeeProviderProps {
    children: ReactNode
}

export function FeeProvider({ children }: FeeProviderProps) {
    const [fee, setFee] = useState<number>(0)

    useEffect(() => {
        getFeeUniversal(setFee)
    }, [])

    function changeFee(n: number) {
        setFee(n)
    }

    return (
        <FeeContext.Provider value={{ changeFee, fee }}>
            {children}
        </ FeeContext.Provider>
    )
}

export function useFee(){
    const context = useContext(FeeContext)
    if (!context) {
        throw new Error('Header deve estar dentro do FeeProvider');
    }
    return context
}
